<script>
import { EventBus, HIDE_ALL_MODALS } from '../../event-bus';
import { mapActions, mapGetters } from 'vuex';
import { ProviderMixin } from '../../mixins/provider';
export default {
  mixins: [ProviderMixin],
  data() {
    return {
      isShowing: false,
    };
  },
  computed: {
    ...mapGetters('notifications', ['isQueueNotification']),
  },
  created() {
    EventBus.$on(HIDE_ALL_MODALS, () => {
      this.hide();
      this.setIsShowingLoginModal(false);
    });
  },
  beforeDestroy() {
    EventBus.$off(HIDE_ALL_MODALS);
  },
  methods: {
    ...mapActions({
      setQueueNotification: 'notifications/setIsQueueNotification',
      setIsShowingLoginModal: 'app/setIsShowingLoginModal',
      setModalRegister: 'tournament/setModalRegister',
    }),
    show(queueNotification = false) {
      this.isShowing = true;
      this.disableScroll();
      if (queueNotification) {
        this.setQueueNotification(queueNotification);
      }
      this.toggleChatIconOnMobile(false);
    },
    hide() {
      this.isShowing = false;
      this.enableScroll();
      if (this.isQueueNotification) {
        this.setQueueNotification(false);
      }
      this.toggleChatIconOnMobile(true);
    },
    disableScroll() {
      document.documentElement.style['overflow-y'] = 'hidden';
    },
    enableScroll() {
      document.documentElement.style['overflow-y'] = 'auto';
    },
    hideModalRegister() {
      this.setModalRegister({ tour_id: 0, modal: '' });
      this.enableScroll();
    },
  },
};
</script>
